<ng-container *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <form (submit)="submitSearch()">
            <tt-input ttLabel="docarc_searchtext" [(ttModel)]="setting.docarc_searchtext" (ttModelChange)="onChanged($event, 'docarc_searchtext')" ttShowClearButton [ttButtons]="docArcSearchTextButtons"></tt-input>
        </form>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</ng-container>


<!--<tt-page class="col-xs-12 sp-0 height-full">
    <tt-header ng-if="vm.model.setting.page_heading > ''" tt-model="vm.model.setting.page_heading"></tt-header>

    <tt-card class="col-xs-12 col-md-4 p-5">
        <form class="form-horizontal im-no-pad" name="formAddExistingDocArc" novalidate ng-submit="vm.submitSearch()" method="get" role="form">
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="docarc_searchtext" tt-focus="true" tt-model="vm.model.setting.docarc_searchtext" tt-change="vm.onChanged($value, 'docarc_searchtext')" tt-placeholder="" tt-buttons="vm.model.docArcSearchTextButtons"></tt-input-buttons>
        </form>
    </tt-card>

    <tt-grid ng-if="vm.model.gridReady" class="col-xs-12 p-5 flex-1" tt-options="vm.grid"></tt-grid>
</tt-page>-->
